import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "VENDAS MOBILE",
  description: "Generated by ASKSYSTEMS",
};
